import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { primaryColor } from "../../Constants";


const MuiDatePicker = ({
  label,
  value,
  onChange,
  disabled,
  maxDate,
  minDate,
  views,
  openTo,
  format,
  required,
}) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: primaryColor,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: value && primaryColor,
              borderWidth: value && "2px" // Keep border color when not focused
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: primaryColor,
            },
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label={
            required ? (
              <span>
                {label}
                <span style={{ color: primaryColor }}> *</span>
              </span>
            ) : (
              label
            )
          }
          value={value}
          onChange={(date) => {
            if (date) {
              onChange(date); // Updates selected date
              setOpen(false); // Closes picker after selection
            } else {
              onChange(null);
            }
          }}
          disabled={disabled}
          maxDate={maxDate || null}
          minDate={minDate || null}
          views={views}
          openTo={openTo}
          format={format}
          open={open}
          onClose={() => setOpen(false)} // ✅ Closes on outside click
          onOpen={() => setOpen(true)} // ✅ Opens when input is clicked
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              inputProps: { readOnly: true },
            },
            popper: { sx: { zIndex: 1300 } },
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default MuiDatePicker;